var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTypo3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff8700"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.093 21.3a3.847 3.847 0 0 1 -1.18.165c-3.555 0-8.778-12.424-8.778-16.559 0-1.523.362-2.031.87-2.466-4.352.503-9.575 2.099-11.244 4.13a4.048 4.048 0 0 0 -.58 2.321c0 6.457 6.891 21.109 11.752 21.109 2.248 0 6.041-3.7 9.16-8.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.823 2c4.5 0 9 .725 9 3.264 0 5.151-3.264 11.389-4.933 11.389-2.974 0-6.673-8.269-6.673-12.4 0-1.886.725-2.249 2.611-2.249"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTypo3);
export default __webpack_public_path__ + "static/media/logo-typo3.594f3858cf4560a5abe7812254961d2c.svg";
export { ForwardRef as ReactComponent };